export default __webpack_public_path__ + "static/polygon-1140771b39c8269a6d1bc5534371f51d.png";